import Vue from 'vue/dist/vue.min.js';
import store from './store';
import VModal from 'vue-js-modal';
import { releaseNotesModal } from "./modals";

const softwareCard = () => {
    Vue.use(VModal);
    let software = document.querySelectorAll('.softward-card--nofilter');

    let softwareCardConstructor = (id) => {
        Vue.component('software-card-single', {
            data: function() {
                return {
                    isBookmarked: false,
                    id: null,
                    type: null
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites[`${this.type}`];
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                }
            },
            methods: {
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: this.type,
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                toggleModal() {   
                    let releaseNotes = this.$refs.releaseNotes.innerHTML;
                    this.$modal.show(
                        releaseNotesModal.template(releaseNotes),
                        releaseNotesModal.name,
                        releaseNotesModal.options
                    )
                },
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.softwareId ? this.$refs.bookmark.dataset.softwareId : null;

                this.type = "softwareId";
                
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
            }
        });

        new Vue({
            el: `.software-card--nofilter-${id}`,
        }).$mount(`.software-card--nofilter-${id}`, true);
    }

    if (software.length > 0) {
        software.forEach((item, index) => {
            item.classList.add(`software-card--nofilter-${index}`);
            softwareCardConstructor(index);
        })
    }

}

export default softwareCard;